import React from "react";
import { Box, Typography, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { selectChartConfig } from "../../selectors/chart";
import { useSelector, useDispatch } from "react-redux";
import { updateChartConfig } from "../../reducer/chart.reducer";
import { TradingSettings as TradingSettingsType } from "../chartV2/chart.typings";
import { chartSettingsSectionDividerSx, chartSettingsSectionTitleSx } from "./chartSettingsLayout";

type Props = {
    viewKey: string;
};

const TradingSettings = ({ viewKey }: Props) => {
    const dispatch = useDispatch();
    const chartConfig = useSelector(selectChartConfig(viewKey));
    const tradingSettings = chartConfig?.tradingSettings;

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, field: keyof TradingSettingsType) => {
        dispatch(updateChartConfig({
            viewKey,
            config: {
                tradingSettings: {
                    ...tradingSettings,
                    [field]: event.target.checked
                }
            },
            createIfAbsent: false
        }));
    };

    return (
        <Box>
            <Typography variant="subtitle1" sx={chartSettingsSectionTitleSx}>
                GENERAL
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(tradingSettings?.showBuySellButtons ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showBuySellButtons")}
                        />
                    }
                    label="Buy/sell buttons"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
            </FormGroup>
            <Typography variant="subtitle1" sx={{ ...chartSettingsSectionTitleSx, ...chartSettingsSectionDividerSx }}>
                TRADING SETTINGS
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(tradingSettings?.showTradeFromChart ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showTradeFromChart")}
                        />
                    }
                    label="Orders / Positions"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(tradingSettings?.showOrderMarkersOnChart ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showOrderMarkersOnChart")}
                        />
                    }
                    label="Order Execution Markers"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(tradingSettings?.showAlertsOnChart ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showAlertsOnChart")}
                        />
                    }
                    label="Price alerts on chart"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
            </FormGroup>
        </Box>
    );
};

export default TradingSettings;